import axios from 'axios';
import {
  getAccessToken,
  liffGetProfile,
} from '../services/promotion/auth.service';
import { getCustomerFOA } from '../services/promotion/foa.service';

const AxiosLibrary = axios.create();

AxiosLibrary.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  const liffProfile = await liffGetProfile();
  const customer = await getCustomerFOA(liffProfile.userId);
  config.headers.authorization = `Bearer ${token}`;
  config.headers.account = `${customer?.amwayNumber}`;
  config.headers.customer = `${customer?.partyId}`;
  return config;
});

export default AxiosLibrary;
